import {BaseCommandMessage, BaseResponseMessage} from "./base";
import {LetterDto, LetterThreadDto} from "../letters";

/**
 * Отправить письмо. Повтор запроса с тем же `clientId` возвращает уже сохранённое письмо.
 * См. `docs/specs/letters.md` §6.1.
 */
export namespace SendLetterCommandNamespace {
    export const COMMAND = 'send_letter';

    export class Request extends BaseCommandMessage {
        constructor(readonly to: string, readonly text: string, readonly clientId: string) {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly letter: LetterDto) {
            super(COMMAND, id, true);
        }
    }
}

/**
 * Список переписок (до 200 последних). См. `docs/specs/letters.md` §6.2.
 */
export namespace GetLetterThreadsCommandNamespace {
    export const COMMAND = 'get_letter_threads';

    export class Request extends BaseCommandMessage {
        constructor() {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(
            override readonly id: number,
            readonly threads: LetterThreadDto[],
            readonly unreadTotal: number
        ) {
            super(COMMAND, id, true);
        }
    }
}

/**
 * Лента одной переписки с пагинацией вверх: `before` — id письма, старее которого нужны письма.
 * См. `docs/specs/letters.md` §6.3.
 */
export namespace GetLettersCommandNamespace {
    export const COMMAND = 'get_letters';

    export const DEFAULT_LIMIT = 30;
    export const MAX_LIMIT = 50;

    export class Request extends BaseCommandMessage {
        constructor(readonly peer: string, readonly before?: string, readonly limit?: number) {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(
            override readonly id: number,
            readonly letters: LetterDto[],
            readonly hasMore: boolean
        ) {
            super(COMMAND, id, true);
        }
    }
}

/**
 * Пометить прочитанными письма от `peer` мне с `_id <= upTo`. См. `docs/specs/letters.md` §6.4.
 */
export namespace MarkLettersReadCommandNamespace {
    export const COMMAND = 'mark_letters_read';

    export class Request extends BaseCommandMessage {
        constructor(readonly peer: string, readonly upTo: string) {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly unreadTotal: number) {
            super(COMMAND, id, true);
        }
    }
}

/**
 * Удалить переписку у себя (у собеседника она остаётся). См. `docs/specs/letters.md` §6.5.
 */
export namespace DeleteLetterThreadCommandNamespace {
    export const COMMAND = 'delete_letter_thread';

    export class Request extends BaseCommandMessage {
        constructor(readonly peer: string) {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly unreadTotal: number) {
            super(COMMAND, id, true);
        }
    }
}

/**
 * Пуш получателю, если он онлайн. См. `docs/specs/letters.md` §6.6.
 */
export namespace LetterReceivedCommandNamespace {
    export const COMMAND = 'letter_received';

    export class Response extends BaseResponseMessage {
        constructor(
            readonly letter: LetterDto,
            readonly thread: LetterThreadDto,
            readonly unreadTotal: number
        ) {
            super(COMMAND, 0, true);
        }
    }
}

/**
 * Пуш отправителю, если он онлайн: собеседник прочитал письма до `upTo` включительно.
 * См. `docs/specs/letters.md` §6.6.
 */
export namespace LettersReadCommandNamespace {
    export const COMMAND = 'letters_read';

    export class Response extends BaseResponseMessage {
        constructor(readonly by: string, readonly upTo: string, readonly readAt: number) {
            super(COMMAND, 0, true);
        }
    }
}
